export default [
  {
    path: '/lotteryDigital',
    name: 'lotteryDigital',
    component: () => import('@/views/lottery/digital'),
    meta: { title: '六合彩' }
  },
  {
    path: '/betSlip',
    name: 'betSlip',
    component: () => import('@/views/lottery/betSlip'),
    meta: { title: '投注单' }
  },
  {
    path: '/recentDraws',
    name: 'recentDraws',
    component: () => import('@/views/lottery/recentDraws'),
    meta: { title: '近期开奖' }
  },
  {
    path: '/lottery/order',
    name: 'lotteryOrder',
    component: () => import('@/views/lottery/order'),
    meta: { title: '购彩记录', keepAlive: true }
  },
  {
    path: '/lottery/orderInfo',
    name: 'lotteryOrderInfo',
    component: () => import('@/views/lottery/orderInfo'),
    meta: { title: '投注详情' }
  },
  {
    path: '/lottery/howPlay',
    name: 'howPlay',
    component: () => import('@/views/lottery/howPlay'),
    meta: { title: '玩法说明' }
  },
]



// WEBPACK FOOTER //
// ./src/router/config/lotteryRouter.js